import { render, staticRenderFns } from "./display-field-favorite.vue?vue&type=template&id=69616399&scoped=true&"
import script from "./display-field-favorite.ts?vue&type=script&lang=ts&"
export * from "./display-field-favorite.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-favorite.scss?vue&type=style&index=0&id=69616399&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69616399",
  null
  
)

export default component.exports